import React from 'react';
import './DowLoader.css';

// Brand loader: the Drive On Wheels logo sitting inside a wheel — an orange
// arc rolling one way on the outer ring, a blue arc the other way on the
// inner ring — in the logo's own colours. Circle only, nothing else.
const SIZES = { md: 88, lg: 120, xl: 160 };

export const DowLoader = ({ size = 'lg', label, fullscreen = false, className = '' }) => {
  const d = SIZES[size] || SIZES.lg;

  const mark = (
    <div className={`dow-loader ${className}`} role="status" aria-label={label || 'Loading'}>
      <div className="dow-loader-wheel" style={{ width: d, height: d }}>
        <svg className="dow-loader-rings" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* tracks */}
          <circle cx="50" cy="50" r="46" stroke="#e5e7eb" strokeWidth="4" />
          <circle cx="50" cy="50" r="38.5" stroke="#eef2f7" strokeWidth="3" />
          {/* outer orange arc — rolls clockwise */}
          <circle className="dow-loader-arc-outer" cx="50" cy="50" r="46" stroke="#f7941d" strokeWidth="4" strokeLinecap="round" strokeDasharray="92 197" />
          {/* inner blue arc — rolls the other way */}
          <circle className="dow-loader-arc-inner" cx="50" cy="50" r="38.5" stroke="#1e88e5" strokeWidth="3" strokeLinecap="round" strokeDasharray="58 184" />
        </svg>
        <img className="dow-loader-logo" src="/logo-dow.png" alt="" />
      </div>
      {label && (
        <p className="dow-loader-label">
          {label.replace(/[.…]+$/, '')}
          <span className="dow-loader-dots"><i>.</i><i>.</i><i>.</i></span>
        </p>
      )}
    </div>
  );

  if (!fullscreen) return mark;
  return <div className="dow-loader-screen">{mark}</div>;
};

export default DowLoader;
